"use strict";

var OutfallsSimpleLayer = function () {
  const layerName = "outfallsSimple";
  const layerKey = "outfallsSimpleLayer";
  var Outfall;

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    Outfall = new Outfalls(
      layerName,
      layerKey,
      OutfallsIcon.getOutfallsMarker,
      ReportApiCalls.getOutfalls,
    );
    Outfall.loadToggledListenerForMap(map, mapLayers, mapId);
    Outfall.loadDataUpdatedListenerForMap(map, mapLayers, mapId);
    Outfall.loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  var loadLayer = function () {
    Outfall.loadOutfalls();
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
  };
};

module.exports = OutfallsSimpleLayer();

const Outfalls = require("./outfalls");
const OutfallsIcon = require("./outfallsIcon");
const ReportApiCalls = require("../reportApiCalls");
